export const WHATSAPP_MESSAGE = `Hi Maaliondoor Team 👋
I’m interested in ordering flowers, plants, chocolates, or gifting products. 🌸🎁

Please help me with the available options, prices, and delivery details.`

export const WHATSAPP_PHONE = '919990926315'

export const WHATSAPP_HREF = `https://api.whatsapp.com/send?phone=${WHATSAPP_PHONE}&text=${encodeURIComponent(WHATSAPP_MESSAGE)}`

export const SITE_ACTIONS = {
  whatsappLabel: 'WhatsApp',
  whatsappHref: WHATSAPP_HREF,
  whatsappIcon: '/images/social/whatsapp.svg',
  backToTop: 'Back to top',
  showAfterPx: 120,
  iconSize: 28,
} as const
